import { useState, useEffect } from "react";
import { useLocalization } from "../../../context/LocalizationContext";
import { useLocation } from "react-router-dom";
import "./TopBar.css";
import balsamee from "../../../assets/images/balsamee.svg";
import tawuniya from "../../../assets/images/tawuniya.svg";
import meena from "../../../assets/images/meena.svg";
import leen from "../../../assets/images/leen.svg";
import careware from "../../../assets/images/careware.svg";
import { getUrlPrefix } from "../../../utils/helpers";

const TopBar = () => {
  const { language } = useLocalization();
  const location = useLocation();
  const podIP = getUrlPrefix(location.pathname);

  // Simple function to get formatted time based on language
  const getFormattedTime = () => {
    const now = new Date();
    return now.toLocaleTimeString(language === "ar" ? "ar-SA" : "en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  const [currentTime, setCurrentTime] = useState(getFormattedTime());
  const logos =
    podIP == "192.168.1.100"
      ? [
        { src: balsamee, alt: "Balsamee" },
        { src: careware, alt: "careware" },
        { src: "", alt: "" },
      ]
      : podIP == "192.168.1.200"
        ?
        [
          { src: balsamee, alt: "Balsamee" },
          { src: leen, alt: "Leen" },
          { src: "", alt: "" },
        ]
        : [
          { src: balsamee, alt: "Balsamee" },
          { src: tawuniya, alt: "Tawuniya" },
          { src: meena, alt: "Meena" },
        ];

  useEffect(() => {
    // Update time every second
    const interval = setInterval(() => {
      setCurrentTime(getFormattedTime());
    }, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [language]);

  if (location.pathname === "/redirect") {
    return null;
  }

  const Logo = ({ logo }) => {
    return (
      <div className="logo-container" key={logo.alt}>
        <img src={logo.src} alt={logo.alt} className="logo-icon" />
      </div>
    );
  };

  return (
    <>
      <div className="top-bar">
        <div className="logos">
          {logos.map((logo) => (
            <Logo logo={logo} key={logo.alt} />
          ))}
        </div>
        <div className="time">{currentTime}</div>
      </div>
    </>
  );
};

export default TopBar;
